<template>
  <main>
    <b-form-row>
      <b-form-checkbox v-model="isSearch" @change="decide" name="check-button" switch>
        Αναζήτηση βάσει ΑΣΜ
      </b-form-checkbox>
      <b-form-checkbox v-model="isAdvanced" @change="decide" name="check-button" switch style="margin-left: 2em">
        Σύνθετη αναζήτηση
      </b-form-checkbox>
    </b-form-row>
    <br>
    <br>
    <div v-if="isSearch && !isAdvanced">
      <b-card>
        <b-form v-on:submit.prevent="noop">
          <b-form-row>
            <b-input-group>
              <b-form-input type="text" placeholder="ΑΣΜ" v-model="searchedEfsa"
                            :state="efsaValidation"></b-form-input>
              <b-form-invalid-feedback :state="efsaValidation">
                Ο Αριθμός Στρατιωτικού Μητρώου (ΑΣΜ) πρέπει να αποτελείται 11 ψηφία
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-row>
          <br>
          <b-row class="justify-content-center">
            <b-col md="1.5">
              <b-button block variant="primary" v-on:click="fetchSingleData" v-bind:disabled="!efsaValidation">
                ΑΝΑΖΗΤΗΣΗ
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </div>
    <div v-if="isAdvanced && !isSearch">
      <b-card>
        <b-form>
          <b-form-row>
            <b-col md="6">
              <b-form-group label-for="name" label="Όνομα">
                <b-form-input id="name" v-model="searchedFirstName" :state="advancedSearchValidation"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label-for="last_name" label="Επίθετο">
                <b-form-input id="last_name" v-model="searchedLastName" :state="advancedSearchValidation"></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col md="6">
              <b-form-group label-for="email" label="Email">
                <b-form-input id="email" v-model="searchedEmail" :state="advancedSearchValidation"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label-for="afm" label="ΑΦΜ">
                <b-form-input id="afm" v-model="searchedAfm" :state="advancedSearchValidation"></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-invalid-feedback :state="advancedSearchValidation">
            Η συμπλήρωση τουλάχιστον ενός πεδίου αναζήτησης είναι απαραίτητη
          </b-form-invalid-feedback>

          <br>
          <b-row class="justify-content-center">
            <b-col md="3">
              <b-button variant="primary" v-on:click="fetchSingleData" v-bind:disabled="!advancedSearchValidation">
                ΑΝΑΖΗΤΗΣΗ
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </div>
    <br>
    <b-row class="d-flex justify-content-center">
      <b-container fluid="lg" style="min-width: 1300px;">
        <span style="color: #7f7f7f">Σύνολο: {{ totalItems }}</span>
        <b-row class="justify-content-end">
          <b-button v-b-modal.filterExports variant="success" size="sm" >
            <b-icon icon="cloud-download" aria-hidden="true"></b-icon>
            Κατέβασμα σε excel
          </b-button>
          <b-modal id="filterExports" title="Επιλογές για καταφόρτωση Εφέδρων">
            <b-form-checkbox-group
                id="checkbox-filterByDate"
                :options="options"
                v-model="filterExportsValue"
                value-field="value"
                text-field="name"
                @change="clearCalendar"
            />
            <div class="d-flex flex-column align-items-center mt-3">
              <div class="d-flex mt-3 text-center ">
                <b-form-datepicker class="mr-3" v-bind="labels['el']" v-model="DateRange.startingDate" :disabled="!(filterExportsValue === 'filterByDate')" :max=curDate placeholder="Eπιλέξτε το αρχικό διάστημα" locale="el-GR"/>
                <b-form-datepicker v-bind="labels['el']" v-model="DateRange.endingDate" :disabled="!(filterExportsValue === 'filterByDate')"  :min="DateRange.startingDate" :max=curDate placeholder="Eπιλέξτε το τελικό διάστημα" locale="el-GR" />
              </div>
            </div>
            <template #modal-footer>
              <b-button class="m-3" variant="primary" :disabled="!dlExcelFiltered" v-on:click="exportChanges">Κατέβασμα σε Excel</b-button>
            </template>
          </b-modal>
        </b-row>
        <b-row class="overflow-auto">
          <b-table class="efedros-table" show-empty :items="verifiedUsers"
                   :fields="fields"
                   :current-page="currentPage"
                   :per-page="0"></b-table>
          <b-pagination size="md" :total-rows="totalItems" @change="pageChange" v-model="currentPage"
                        :per-page="perPage"></b-pagination>
        </b-row>
      </b-container>
    </b-row>
  </main>
</template>

<script>

import { HTTP } from "@/main";

export default {
  data: function () {
    return {
      DateRange: {
        startingDate: null,
        endingDate: null,
      },
      options: [
        { item:'A', name: 'Φιλτράρισμα εφέδρων με ημερομηνία εγγραφής', value: 'filterByDate', disabled: false },
        { item:'B', name: 'Επιλογή Όλων', value: 'allSelected', disabled: false },
      ],
      labels: {
        el: {
          labelPrevYear: 'Προηγούμενο Έτος',
          labelPrevMonth: 'Προηγούμενος Μήνας',
          labelCurrentMonth: 'Τωρινός Μήνας',
          labelNextMonth: 'Επόμενος Μήνας',
          labelNextYear: 'Επόμενο Έτος',
          labelNextDecade: 'Επόμενη Δεκαετία',
          labelToday: 'Σήμερα',
          labelSelected: 'Επιλεγμένη Ημερομηνία',
          labelNoDateSelected: 'Δεν έχει επιλεχθεί Ημερομηνία',
          labelCalendar: 'Ημερολόγιο',
          labelNav: 'Περιήγηση',
          labelHelp: 'Χρησιμοποιήστε τον κέρσορα για να περιηγηθείτε στο ημερολόγιο'
        }
      },

      filterExportsValue: null,
      isSearch: false,
      isAdvanced: false,
      searchedEfsa: null,
      searchedFirstName: null,
      searchedLastName: null,
      searchedEmail: null,
      searchedAfm: null,
      verifiedUsers: [],
      fields: [
        {
          key: 'efSa',
          label: 'ΣΑ'
        },
        {
          key: 'afm',
          label: 'ΑΦΜ'
        },
        {
          key: 'lastName',
          label: 'Επίθετο'
        },
        {
          key: 'firstName',
          label: 'Όνομα'
        },
        {
          key: 'mhtrwoArrenwn',
          label: 'Μητρώο αρρένων'
        },
        {
          key: 'fatherName',
          label: 'Πατρώνυμο'
        },
        {
          key: 'motherName',
          label: 'Μητρώνυμο'
        },
        {
          key: 'xrwmaEfp',
          label: 'Χρώμα ΕΦΠ'
        },
        {
          key: 'sygrotousaMee',
          label: 'Συγκροτούσα ΕΑ'
        },
        {
          key: 'parakolouthousaMee',
          label: 'Παρακολουθούσα ΕΑ'
        },
        {
          key: 'papMee',
          label: 'ΕΑ τήρησης ΦΑΠ'
        },
        {
          key: 'statheroThl',
          label: 'Σταθερό Τηλέφωνο'
        },
        {
          key: 'mobileThl',
          label: 'Κινητό Τηλέφωνο'
        },
        {
          key: 'email',
          label: 'E-mail'
        },
        {
          key: 'date',
          label: 'Ημερομηνία καταχώρησης',
          formatter: (value) => {
            const options = {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            };
            return new Date(value).toLocaleDateString('el-GR', options);
          }
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalItems: 0
    };
  },
  computed: {
    efsaValidation() {
      // check if efsa contains exactly 11 digits
      return (/^\d+$/.test(this.searchedEfsa) && this.searchedEfsa.length === 11);
    },

    advancedSearchValidation() {
      // At least one search field has to be populated by the user
      return ((this.searchedFirstName != null && this.searchedFirstName !== "") ||
          (this.searchedLastName != null && this.searchedLastName !== "") ||
          (this.searchedAfm != null && this.searchedAfm !== "") ||
          (this.searchedEmail != null && this.searchedEmail !== ""))
    },
    dlExcelFiltered() {
      let flag = false
      if (this.filterExportsValue === 'filterByDate') {
        if (this.DateRange.startingDate && this.DateRange.endingDate) {
          flag = true
        }
      }
      else {
        if(this.filterExportsValue === 'allSelected') {
          flag = true
        }
      }
      return(flag)
    },
    curDate() {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    }
  },
  mounted() {
    this.fetchData()
  },
  watch: {
    isSearch() {
      if (this.isSearch)
        this.isAdvanced = false
    },
    isAdvanced() {
      if (this.isAdvanced)
        this.isSearch = false
    }
  },
  methods: {
    clearCalendar(selected) {
      if( selected == 'allSelected') {
        this.DateRange.startingDate = null;
        this.DateRange.endingDate = null;
        console.log(this.DateRange)
      }
    },
    pageChange(page) {
      this.currentPage = page ;
      this.fetchData()
    },
    async decide() {
      if (this.isSearch || this.isAdvanced) {
        this.verifiedUsers = []
        this.totalItems = 0;
        this.perPage = 10;
        this.currentPage = 1;
      }
      else {
        this.perPage = 10;
        this.currentPage = 1;
        this.fetchData();
      }
    },
    async fetchData() {
      let size = this.perPage == null ? 10 : this.perPage;
      let page = this.currentPage === null ? 0 : this.currentPage - 1;
      let url = "/admin/fetch-verified-users?page=" + page + "&size=" + size + "";

      this.$store.dispatch('loading');

      HTTP.get(url).then(response => {
        if (response.data.responseData.content.length > 0) {
          this.verifiedUsers = response.data.responseData.content
          this.totalItems = response.data.responseData.totalElements
        }
      }).catch((error) => {
        console.error(error);
        this.$store.dispatch('stop_loading');
      }).finally(() => {
        this.$store.dispatch('stop_loading');
      });
    },
    async fetchSingleData() {
      let size = this.perPage == null ? 10 : this.perPage;
      let page = this.currentPage == null ? 0 : this.currentPage - 1

      if (!this.isAdvanced) {
        this.searchedLastName = null
        this.searchedFirstName = null
        this.searchedEmail = null
        this.searchedAfm = null
      }
      else {
        this.searchedEfsa = null
      }

      let url = "/admin/search-verified-users?page=" + page + "&size=" + size + "";
      this.$store.dispatch('loading');
      let data = {};
      //Accent is removed for the first and last names typed by the user
      let firstNameWithoutAccent = this.searchedFirstName == null ? null :
          this.searchedFirstName.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      let lastNameWithoutAccent = this.searchedLastName == null ? null :
          this.searchedLastName.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      data = {
        "efsa": this.searchedEfsa,
        "firstName": this.searchedFirstName !== "" ? firstNameWithoutAccent : null,
        "lastName": this.searchedLastName !== "" ? lastNameWithoutAccent : null,
        "email": this.searchedEmail !== "" ? this.searchedEmail : null,
        "afm": this.searchedAfm !== "" ? this.searchedAfm : null
      };

      if (data.firstName != null) data.firstName = data.firstName.toLowerCase();
      if (data.lastName != null) data.lastName = data.lastName.toLowerCase();

      HTTP.post(url, data).then(response => {
        this.verifiedUsers = response.data.responseData.content
        this.totalItems = response.data.responseData.totalElements
      }).catch((error) => {
        console.error(error);
        this.$bvToast.toast("Υπήρξε κάποιο πρόβλημα", {
          title: `Αδύνατη αναζήτηση`,
          variant: 'danger',
          solid: true
        });
        this.users = []
        this.$store.dispatch('stop_loading');
      }).finally(() => {
        this.$store.dispatch('stop_loading');
      });
    },
    exportChanges() {
      let url = "/admin/download-verified-users"
      if (this.DateRange.startingDate !== null && this.DateRange.endingDate !== null) {
        this.DateRange.startingDate += 'T00:00'
        this.DateRange.endingDate += 'T23:59'
        url += `?startDate=${this.DateRange.startingDate}&endDate=${this.DateRange.endingDate}`
      }
      this.$store.dispatch("loading")
      HTTP.get(url, {
        responseType: 'blob'
      }).then(res => {
        let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'efedros_verified_users.xls';
        link.click();
      }).finally(() => this.$store.dispatch("stop_loading"))
    }
  }
};
</script>
               